import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectInlineFormalQuote } from 'formal_quote/inline_formal_quote/redux/selectors';
import { Modal, Button } from 'react-bootstrap';
import { dismissSuccessModal } from 'formal_quote/inline_formal_quote/redux/slice';

const SuccessModal = () => {
  const { successModal } = useSelector(selectInlineFormalQuote);
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(dismissSuccessModal());
  };

  return (
    <Modal
      show={successModal}
      onHide={onDismiss}
      centered
      className="formal-quote-success-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="sr-only">Success</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pb-4">
        <div className="mb-3">
          <img
            src={Spree.image_assets.success}
            alt="Success"
            width="48"
            height="48"
          />
        </div>

        <h4 className="font-weight-bold text-dark mb-2">
          Software Product Formal Quote Request Received!
        </h4>

        <p className="text-muted mb-4">
          The Pentalogix Sales team&apos;ll be sending an email with your quote
          within the next few hours.
        </p>

        <div className="d-flex flex-column flex-sm-row justify-content-center">
          <Button variant="dark" onClick={onDismiss}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
